const normalizeText = (value) => String(value || '').trim();

export const validateBookingPayload = (payload) => {
  const errors = [];

  if (!payload || typeof payload !== 'object') {
    return { valid: false, errors: ['Booking payload must be an object.'] };
  }

  const service = payload.service || payload.booking?.service;
  const packageInfo = payload.package || payload.booking?.package;

  if (!service || typeof service !== 'object') {
    errors.push('Booking service details are missing.');
  }

  if (!packageInfo || typeof packageInfo !== 'object') {
    errors.push('Booking package details are missing.');
  }

  if (service && !normalizeText(service.title || service.name)) {
    errors.push('Service title is required.');
  }

  if (packageInfo && !normalizeText(packageInfo.name)) {
    errors.push('Package name is required.');
  }

  return {
    valid: errors.length === 0,
    errors
  };
};

export const validateLeadPayload = (payload) => {
  const errors = [];

  if (!payload || typeof payload !== 'object') {
    return { valid: false, errors: ['Lead payload must be an object.'] };
  }

  if (!normalizeText(payload.serviceTitle)) {
    errors.push('Lead serviceTitle is required.');
  }

  if (!normalizeText(payload.customerName)) {
    errors.push('Lead customerName is required.');
  }

  const phone = normalizeText(payload.customerPhone).replace(/\D/g, '');
  const email = normalizeText(payload.customerEmail);
  if (!phone && !email) {
    errors.push('At least one customer contact (phone or email) is required.');
  }

  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.push('Lead customerEmail format is invalid.');
  }

  const amount = Number(payload.totalPrice);
  if (!Number.isFinite(amount) || amount < 0) {
    errors.push('Lead totalPrice must be a valid non-negative number.');
  }

  return {
    valid: errors.length === 0,
    errors
  };
};

export default {
  validateBookingPayload,
  validateLeadPayload
};
